import { LoadingButton } from '@mui/lab';
import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import { SnackbarContext } from '../../Providers/SnackbarProvider';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Error } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { graphql } from 'gql';
import { namedOperations } from 'gql/graphql';

const CascadeDeleteSeason = graphql(`
    mutation CascadeDeleteSeason_DeleteSeasonDialog($seasonId: ID!) {
        cascadeDeleteSeason(seasonId: $seasonId) {
            nodesDeleted
            relationshipsDeleted
        }
    }`);

type Props = {
    open: boolean;
    onClose: () => void;
}

export default function DeleteSeasonDialog({ open, onClose }: Props) {
    const navigate = useNavigate();

    const { selectedSeason, setSelectedSeason } = useContext(SeasonShowContext);
    const { success, error } = useContext(SnackbarContext);

    const [deleteSeason, { loading }] = useMutation(CascadeDeleteSeason);

    const handleYes = async () => {
        try {
            await deleteSeason({
                variables: { seasonId: selectedSeason!.id },
                refetchQueries: [
                    namedOperations.Query.GetSeasonFromShow_SeasonShowProvider,
                    namedOperations.Query.GetEpisodesForSeason_Layout,
                    namedOperations.Query.EpisodeLines,
                ],
            });
            setSelectedSeason(null);
            navigate('/');
            onClose();
            success('Season deleted');
        } catch (e) {
            // @ts-ignore
            error('Failed to delete show. ' + e.message);
        }
    }

    if (!selectedSeason) {
        return null;
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Delete Show</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete the season {selectedSeason.title}?</Typography>
                <Typography color='error' variant='caption'>It will be gone forever!</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='text' color='inherit'>No</Button>
                <LoadingButton
                    onClick={handleYes}
                    startIcon={<Error />}
                    variant='text'
                    color='error'
                    loading={loading}
                >
                    Yes
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}